/**
 * Created by Анжелика on 25.09.2017.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {Link} from 'react-router';
import PropTypes from 'prop-types';
import * as ChannelCardsActions from '../actions/channelCards';

class ChannelCards extends Component {

    channelCardClick(channel) {
        const {activeChannel, channelCardsActions, onItemClick} = this.props;
        if (channel.channelID !== activeChannel.channelID) {
            channelCardsActions.playChannelCard(channel);
            if (onItemClick){
                onItemClick();
            }
        }
    }

    render() {
        const {channelCards, activeChannel} = this.props;
        return (
            <div className="channel-cards">
                {channelCards.map((channel, index) => (
                    <Link key={index} to={`/channels/${channel.channelID}`} onClick={this.channelCardClick.bind(this, channel)}>
                        <div className={"card" + (activeChannel && activeChannel.channelID === channel.channelID ? ' active' : '')}>
                            <div className="wrapper">
                                {channel.image && <img src={channel.image} alt=""/>}
                                <div className="card-details">
                                    <div className="name">{channel.name}</div>
                                </div>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        )
    }
}

ChannelCards.propTypes = {
    channelCards: PropTypes.array.isRequired,
    activeChannel: PropTypes.object,
    channelCardsActions: PropTypes.object.isRequired,
    onItemClick: PropTypes.func
};

const mapStateToProps = state => {
    return {
        channelCards: state.channelCards.items,
        activeChannel: state.channels.activeChannel
    }
};

const mapDispatchToProps = dispatch => {
    return {
        channelCardsActions: bindActionCreators(ChannelCardsActions, dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChannelCards);


// WEBPACK FOOTER //
// ./src/containers/ChannelCards.js